import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

export const DEFAULTS = {
  colors: { bg: "#FBE9EE", section: "#F6DCE4", border: "#EFCBD7", accent: "#C4839B", dark: "#43242E", muted: "#8A6B74" },
  fonts: { heading: "Cormorant Garamond", body: "Manrope" },
  texts: {
    hero_overline: "Institut de beauté — Paris",
    hero_line1: "Révélez",
    hero_line2: "votre",
    hero_line3: "beauté.",
    hero_subtitle: "Cils, sourcils & tatouage — un savoir-faire d'exception, signé Armina.",
    marquee_items: ["Extensions de cils", "Sourcils", "Tatouage", "Beauty by Armina"],
  },
  images: {
    hero: "https://images.pexels.com/photos/13068377/pexels-photo-13068377.jpeg?auto=compress&cs=tinysrgb&w=1600",
    categories: {
      Cils: "https://images.unsplash.com/photo-1548902378-2ec44c906391?q=80&w=900&auto=format&fit=crop",
      Sourcils: "https://images.unsplash.com/photo-1581003250898-36050e78fcd3?q=80&w=900&auto=format&fit=crop",
    },
    tattoo_gallery: [
      "https://images.unsplash.com/photo-1611501275019-9b5cda994e8d?q=80&w=900&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1598371839696-5c5bb00bdc28?q=80&w=900&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1542727365-19732a80dcfd?q=80&w=900&auto=format&fit=crop",
    ],
  },
  gallery: [
    { src: "https://images.unsplash.com/photo-1548902378-2ec44c906391?q=80&w=900&auto=format&fit=crop", tag: "Cils", alt: "Extensions de cils" },
    { src: "https://images.unsplash.com/photo-1581003250898-36050e78fcd3?q=80&w=900&auto=format&fit=crop", tag: "Sourcils", alt: "Microblading sourcils" },
    { src: "https://images.unsplash.com/photo-1611501275019-9b5cda994e8d?q=80&w=900&auto=format&fit=crop", tag: "Tatouage", alt: "Séance de tatouage" },
    { src: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?q=80&w=900&auto=format&fit=crop", tag: "Cils", alt: "Maquillage du regard" },
    { src: "https://images.unsplash.com/photo-1598371839696-5c5bb00bdc28?q=80&w=900&auto=format&fit=crop", tag: "Tatouage", alt: "Tatouage fine line" },
  ],
  salon: {
    address: "12 rue des Fleurs, 75004 Paris",
    phone: "01 84 80 20 20",
    hours: "Mardi – Samedi · 9h00 – 19h00",
    instagram: "@beautybyarmina",
    instagram_url: "https://instagram.com/beautybyarmina",
    tiktok: "@beautybyarmina",
    tiktok_url: "https://tiktok.com/@beautybyarmina",
    whatsapp_url: "https://wa.me/33601020304",
  },
};

export const FONT_OPTIONS = {
  heading: ["Cormorant Garamond", "Playfair Display", "Marcellus", "Italiana", "Lora", "DM Serif Display"],
  body: ["Manrope", "Jost", "Montserrat", "Nunito Sans", "Lato", "Raleway"],
};

export function imgSrc(url) {
  if (url && url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

function fontUrl(families) {
  const params = families.map((f) => `family=${f.replace(/ /g, "+")}:ital,wght@0,300;0,400;0,500;0,600;1,400`).join("&");
  return `https://fonts.googleapis.com/css2?${params}&display=swap`;
}

function applyTheme(s) {
  const root = document.documentElement;
  Object.entries(s.colors || {}).forEach(([k, v]) => root.style.setProperty(`--brand-${k}`, v));
  root.style.setProperty("--font-heading", `"${s.fonts.heading}"`);
  root.style.setProperty("--font-body", `"${s.fonts.body}"`);
  let link = document.getElementById("dynamic-fonts");
  if (!link) {
    link = document.createElement("link");
    link.id = "dynamic-fonts";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = fontUrl([s.fonts.heading, s.fonts.body]);
}

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const load = () =>
    api.get("/settings")
      .then((res) => {
        const merged = { ...DEFAULTS, ...res.data };
        setSettings(merged);
        applyTheme(merged);
      })
      .catch(() => {});

  useEffect(() => {
    load();
  }, []);

  return <SettingsContext.Provider value={{ settings, refresh: load }}>{children}</SettingsContext.Provider>;
}
